import React, { useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Grid,
  Tabs,
  Tab,
  Alert,
  List,
  Chip,
  Button,
} from '@mui/material';
import {
  School,
  Warning,
  Phone,
  Download,
  Block,
  CheckCircle,
  Home,
} from '@mui/icons-material';

const SchoolRules = () => {
  const [tabValue, setTabValue] = useState(0);

  const generalRules = [
    { no: 1, sw: 'Kuwepo ndani ya mipaka ya shule muda wote wa masomo na kazi.', en: 'Remain within school boundaries at all times during study and work hours.' },
    { no: 2, sw: 'Kuhudhuria vipindi vyote vya shule darasani na nje ya darasa (Kinyume na hapo itafahamika kuwa ni kosa la utoro shuleni).', en: 'Attend all lessons and curricular activities punctually (Absenteeism is strictly treated as truancy).' },
    { no: 3, sw: 'Kuwaheshimu na kuwatii walimu na wafanyakazi wote wa shule bila ubaguzi.', en: 'Respect and obey all teachers and school staff without exception.' },
    { no: 4, sw: 'Ni kosa kutumia lugha mbaya na matusi wakati wote kwa mtu yeyote.', en: 'Use of abusive language, insults, or profanity is strictly forbidden.' },
    { no: 5, sw: 'Kutovaa vidani kama vile hereni, cheni, mikufu, bangili, na kupaka dawa ya nywele.', en: 'Wearing jewelry (earrings, chains, necklaces, bangles) and applying hair chemicals is prohibited.' },
    { no: 6, sw: 'Kutojichora kwa hina au tattoo sehemu yoyote ya mwili.', en: 'Body art, tattoos, and henna are strictly prohibited.' },
    { no: 7, sw: 'Ni lazima kusimama mwalimu anapoingia darasani na kumsalimia kwa heshima.', en: 'Stand and greet teachers respectfully whenever they enter the classroom.' },
    { no: 8, sw: 'Ni kosa kutembelea nyumba za kulala wageni, vilabu na kumbi za starehe.', en: 'Visiting guest houses, bars, or unauthorized entertainment venues is strictly forbidden.' },
    { no: 9, sw: 'Ni kosa kuwa na kucha ndefu au kupaka rangi aina yoyote ya kucha.', en: 'Keep nails short and clean. Nail polish of any kind is prohibited.' },
    { no: 10, sw: 'Wanafunzi wote wanatakiwa kukata nywele nusu inchi (Half inch) kwa wavulana na wasichana.', en: 'All students must maintain neat hair cut to half-inch length.' },
    { no: 11, sw: 'Wavulana hawaruhusiwi kufuga ndevu.', en: 'Boys are strictly prohibited from growing beards.' },
    { no: 12, sw: 'Mwanafunzi anapaswa kuvaa sare ya shule muda wote wa masomo na anapokwenda Hospital kupata matibabu.', en: 'Full school uniform is compulsory during class hours and when attending hospital/clinic.' },
    { no: 13, sw: 'NIMARUFUKU KABISA kumiliki au kutumia simu ya mkononi, simcard, chaja au vocha shuleni (Huduma za dharura zitatolewa ofisi ya Mkuu wa Shule).', en: 'STRICTLY PROHIBITED: Possessing or using mobile phones, SIM cards, chargers, or airtime vouchers.' },
    { no: 14, sw: 'Nimarufuku kuvaa kofia, jaketi, sweta au mavazi ambayo siyo sare rasmi ya shule.', en: 'Wearing unofficial jackets, caps, non-uniform sweaters or casual clothes is prohibited.' },
    { no: 15, sw: 'Kufanya usafi binafsi na usafi wa mazingira ya shule na madarasa kila siku.', en: 'Maintain personal hygiene and participate in cleaning classrooms and school compound daily.' },
    { no: 16, sw: 'Nimarufuku kwenda kwenye nyumba za walimu au wafanyakazi bila ruhusa maalum.', en: 'Entering teachers’ or staff quarters without explicit permission is forbidden.' },
    { no: 17, sw: 'Mafuta yenye harufu kali hayaruhusiwi shuleni.', en: 'Strongly scented oils or perfumes are not allowed.' },
    { no: 18, sw: 'Kuheshimu Bendera ya Taifa na Wimbo wa Taifa wakati wote.', en: 'Show utmost respect to the National Flag and National Anthem.' },
    { no: 19, sw: 'Kutunza mali ya shule (madawati, viti, meza, vioo, majengo). Atakayeharibu atalazimika kulipa na anaweza kufukuzwa shule.', en: 'Protect school property. Any student who causes intentional damage will pay full replacement costs and face disciplinary action.' },
    { no: 20, sw: 'KIINGEREZA NI LUGHA YA MAWASILIANO: Ni lazima kuwasiliana kwa Kiingereza tu muda wote shuleni. Kiswahili kitatumika wakati wa somo la Kiswahili tu.', en: 'ENGLISH IS COMPULSORY: All communication within the school compound must be in English. Kiswahili is used only during Kiswahili periods.' },
  ];

  const boardingRules = [
    'Mwanafunzi atatakiwa kuvaa sare ya shule/shamba dress muda wote awapo bweni.',
    'Mwanafunzi akitoka bwenini kwenda madarasani haruhusiwi kurejea tena pasipo kibali mpaka mwisho wa vipindi.',
    'Nguo za nyumbani HAZIRUHUSIWI. Mwanafunzi aje na sare ya shule tu akiripoti.',
    'HARUHUSIWI kupeleka chakula bwenini au darasani. Chakula kinaliwa bwalo la shule tu.',
    'Simu ya mkononi, simcard, charger au vocha zikikamatwa zitaharibiwa kabisa na mhusika atafukuzwa shule mara moja.',
    'HARUHUSIWI kutembelewa na mgeni yeyote bila ruhusa kutoka ofisi ya Mkuu wa Shule.',
    'Outing day na visiting day zitatangazwa rasmi na Mkuu wa Shule.',
    'Mawasiliano na ndugu yatafanyika ofisi ya Mkuu wa Shule kwa namba maalum za ofisi.',
    'Ruhusa za kutoka nje ya shule zitatolewa na ofisi ya Mkuu wa Shule kwa kibali maalum cha maandishi.',
    'Mwanafunzi atakayeonekana nje ya shule bila sababu au kibali atakuwa ni mtoro na atafukuzwa shule.',
    'Mwanafunzi mgonjwa kulala bwenini lazima apewe kibali cha maandishi na Mkuu wa Shule.',
  ];

  const expulsionOffenses = [
    'Wizi wa aina yoyote ile.',
    'Uasherati, ubakaji, ushoga na ulawiti.',
    'Ulevi na matumizi ya madawa ya kulevya au biashara ya madawa.',
    'Makosa ya jinai ya aina yoyote.',
    'Kupigana au kupiga mwanafunzi mwenzake, mwalimu au mtumishi wa shule.',
    'Kuharibu kwa makusudi mali ya shule au ya mtu mwingine.',
    'Kudharau Bendera ya Taifa au alama za nchi.',
    'Kupata mimba au kusababisha mimba ndani na nje ya shule.',
    'Kutoa mimba au kushawishi kutoa mimba.',
    'Kuoa au kuolewa ukiwa mwanafunzi.',
    'Kugoma au kuchochea migomo na kuvuruga amani na usalama wa shule.',
    'Kukataa adhabu halali iliyotolewa na mwalimu au uongozi.',
    'Utoro wa kukaa nje ya shule bila taarifa kwa zaidi ya SIKU 90.',
    'Kukataa kufanya mazoezi na mitihani ya shule au ya Taifa.',
    'Kuwa na simu ya mkononi, simcard, charger au vocha shuleni au bwenini.',
    'Kutembelea nyumba za kulala wageni, kumbi za starehe, baa na maeneo yasiyoruhusiwa.',
  ];

  return (
    <Box sx={{ bgcolor: '#f4f7fb', minHeight: '100vh', py: { xs: 3, md: 6 } }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 5 },
            borderRadius: 4,
            background: 'linear-gradient(135deg, #1a237e 0%, #0a0a2a 100%)',
            color: 'white',
            textAlign: 'center',
            mb: 4,
            boxShadow: '0 10px 30px rgba(10,10,42,0.3)',
          }}
        >
          <Chip label="Discipline · Excellence · Integrity" sx={{ bgcolor: '#ffd700', color: '#0a0a2a', fontWeight: 800, mb: 2 }} />
          <Typography variant="h3" sx={{ fontWeight: 900, fontSize: { xs: '1.8rem', md: '2.8rem' }, mb: 1 }}>
            Sheria na Taratibu za Shule
          </Typography>
          <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 400, maxWidth: 750, mx: 'auto', mb: 3 }}>
            Kaozya High School &amp; Kaozya English Medium School
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              href="/downloads/FOMU_YA_KUJIUNGA_NA_KAOZYA_HIGH_SCHOOL.pdf"
              download="FOMU_YA_KUJIUNGA_NA_KAOZYA_HIGH_SCHOOL.pdf"
              startIcon={<Download />}
              sx={{ bgcolor: '#ff6f00', color: 'white', fontWeight: 700, borderRadius: 2, textTransform: 'none' }}
            >
              Download Fomu ya Sekondari (PDF)
            </Button>
            <Button
              variant="contained"
              href="/downloads/FOMU_YA_KUJIUNGA_NA_KAOZYA_ENGLISH_MEDIUM.pdf"
              download="FOMU_YA_KUJIUNGA_NA_KAOZYA_ENGLISH_MEDIUM.pdf"
              startIcon={<Download />}
              sx={{ bgcolor: '#2e7d32', color: 'white', fontWeight: 700, borderRadius: 2, textTransform: 'none' }}
            >
              Download Fomu ya Msingi (PDF)
            </Button>
          </Box>
        </Paper>

        <Alert severity="warning" sx={{ mb: 4, borderRadius: 3, fontWeight: 500 }}>
          <strong>ANGALIZO KWA WAZAZI NA WANAFUNZI:</strong> Kujaza na kutuma fomu ya kujiunga kunamaanisha mwanafunzi na mzazi/mlezi wamekubali kwa ukamilifu kufuata na kuzingatia sheria na kanuni zote za shule zilizoorodheshwa hapa chini.
        </Alert>

        {/* Tabs */}
        <Paper sx={{ borderRadius: 3, mb: 4, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>
          <Tabs
            value={tabValue}
            onChange={(_, val) => setTabValue(val)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              bgcolor: '#fff',
              borderBottom: '1px solid rgba(0,0,0,0.08)',
              '& .MuiTab-root': { fontWeight: 800, textTransform: 'none', fontSize: '0.95rem', py: 2 },
              '& .Mui-selected': { color: '#1a237e' },
              '& .MuiTabs-indicator': { bgcolor: '#ff6f00', height: 3 },
            }}
          >
            <Tab icon={<School />} iconPosition="start" label="Sheria Kuu 20 za Shule" />
            <Tab icon={<Home />} iconPosition="start" label="Sheria za Wanafunzi wa Bweni" />
            <Tab icon={<Warning />} iconPosition="start" label="Makosa ya Kufukuzwa Shule" />
          </Tabs>

          {/* TAB 0: 20 Official Rules */}
          {tabValue === 0 && (
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a237e', mb: 3 }}>
                Sheria na Taratibu 20 za Kufuata Wakati Wote Wanafunzi Wanapokuwepo Shuleni
              </Typography>

              <Grid container spacing={2}>
                {generalRules.map((rule) => (
                  <Grid item xs={12} md={6} key={rule.no}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2.5,
                        borderRadius: 2.5,
                        bgcolor: '#fff',
                        border: '1px solid #e2e8f0',
                        height: '100%',
                        transition: 'all 0.2s ease',
                        '&:hover': { borderColor: '#1a237e', boxShadow: '0 4px 12px rgba(26,35,126,0.08)' },
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
                        <Chip
                          label={'#' + rule.no}
                          size="small"
                          sx={{ bgcolor: '#1a237e', color: 'white', fontWeight: 800, minWidth: 36 }}
                        />
                        <Box>
                          <Typography variant="body1" sx={{ fontWeight: 700, color: '#1e293b', mb: 0.5, lineHeight: 1.5 }}>
                            {rule.sw}
                          </Typography>
                          <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem' }}>
                            {rule.en}
                          </Typography>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* TAB 1: Boarding Rules */}
          {tabValue === 1 && (
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#ff6f00', mb: 1 }}>
                Taratibu na Sheria za Nyongeza kwa Wanafunzi wa Bweni (Boarding)
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Sheria hizi zinatumika kwa wanafunzi wote wanaolala bwenini (Hostels)
              </Typography>

              <List>
                {boardingRules.map((rule, idx) => (
                  <Paper key={idx} elevation={0} sx={{ mb: 1.5, p: 2, bgcolor: '#fff', border: '1px solid #fed7aa', borderRadius: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <CheckCircle sx={{ color: '#ff6f00', fontSize: 22, flexShrink: 0 }} />
                      <Typography variant="body1" sx={{ fontWeight: 600, color: '#334155' }}>
                        {idx + 1}. {rule}
                      </Typography>
                    </Box>
                  </Paper>
                ))}
              </List>
            </Box>
          )}

          {/* TAB 2: Expulsion Offenses */}
          {tabValue === 2 && (
            <Box sx={{ p: { xs: 2.5, md: 4 } }}>
              <Typography variant="h5" sx={{ fontWeight: 800, color: '#dc2626', mb: 1 }}>
                Makosa Yanayoweza Kusababisha Mwanafunzi Kufukuzwa Shule Mara Moja
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Orodha rasmi ya makosa makubwa ya nidhamu yanayopelekea kufukuzwa shule (Summary Expulsion)
              </Typography>

              <Grid container spacing={2}>
                {expulsionOffenses.map((offense, idx) => (
                  <Grid item xs={12} sm={6} key={idx}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: '#fef2f2',
                        border: '1px solid #fecaca',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                      }}
                    >
                      <Block sx={{ color: '#dc2626', fontSize: 22, flexShrink: 0 }} />
                      <Typography variant="body2" sx={{ fontWeight: 700, color: '#991b1b' }}>
                        {idx + 1}. {offense}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
        </Paper>

        {/* Emergency Contacts Box */}
        <Paper sx={{ p: 3.5, borderRadius: 3, bgcolor: '#1a237e', color: 'white' }}>
          <Typography variant="h6" sx={{ fontWeight: 800, color: '#ffd700', mb: 2 }}>
            Mawasiliano ya Dharura na Uongozi wa Shule (Emergency Contacts)
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ color: '#ffd700' }} />
                <Box>
                  <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', display: 'block' }}>Mkuu wa Shule (Sec)</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>+255 784 268 575</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ color: '#ffd700' }} />
                <Box>
                  <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', display: 'block' }}>Mkuu wa Shule (EMS)</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>+255 767 705 910</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ color: '#ffd700' }} />
                <Box>
                  <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', display: 'block' }}>Makamu Mkuu</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>+255 655 705 910</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ color: '#ffd700' }} />
                <Box>
                  <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.7)', display: 'block' }}>Mapokezi / Reception</Typography>
                  <Typography variant="body2" sx={{ fontWeight: 700 }}>+255 773 268 575</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default SchoolRules;
